import { createErrorMessage, serviceBase, clearance } from "../service";
import api from "../api";
import axios from "axios";

const DocumentImage = {
  ...serviceBase,
  clearance,
  preList: function(params) {
    let id = params.template_id || "-";
    delete params.template_id;
    return `template-libraries/${id}`;
  },
  resource: "images",
  preListOption: {
    getList: true,
    get: true,
    create: true,
    update: true,
    delete: true,
    deleteList: true
  },
  upload(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    let preList = this.preList(params);
    let imageFile = params.image;
    let url = `${preList ? "/" + preList : ""}/${this.resource}/${
      params.id
    }/file`;
    return api
      .put(url, imageFile, {
        headers: {
          "Content-Type": imageFile.type
        }
      })
      .then(res => {
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  },
  getImage(url, onSuccess = () => {}, onError = () => {}) {
    return axios
      .get(url, {
        responseType: "arraybuffer"
      })
      .then(response => {
        let res = `data:${
          response.headers["content-type"]
        };base64,${Buffer.from(response.data, "binary").toString("base64")}`;
        onSuccess(res);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  },
  getImageFileUrl(id) {
    return `${api.apiUrl}/${this.preList({})}/${this.resource}/${id}/file`;
  }
};
export default DocumentImage;
